import { __extends, __assign, __decorate, __metadata } from 'tslib';
import { Prop, Component, Vue } from 'vue-property-decorator';
import { EnumProp } from '../../utils/enumProp.js';
import __vue_component__$2 from '../HseClickableIcon/HseClickableIcon.vue.js';
import __vue_component__ from '../../icons/action/delete/IconActionDelete.vue.js';
import { colorGrayDusk, colorBaseWhite, colorBrand5, colorBaseBlack } from '@hse-design/tokens';
import __vue_component__$1 from '../HsePopper/HsePopper.vue.js';
import { TooltipVariant } from './TooltipVariant.js';

/**
 * @figma https://www.figma.com/file/cBHD57QcCt9WDT4e7e2B3w/hse_general_library?node-id=941%3A0
 * @storybook /?path=/story/tooltip-tooltip--playground
 * @react /src-components-tooltip
 * @reactStorybook /?path=/story/tooltip-tooltip--playground
 */
var HseTooltip = /** @class */ (function (_super) {
    __extends(HseTooltip, _super);
    function HseTooltip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.innerVisible = false;
        _this.appendToEl = null;
        return _this;
    }
    Object.defineProperty(HseTooltip.prototype, "listeners", {
        get: function () {
            return __assign(__assign({}, this.$listeners), { mouseenter: this.onMouseEnter, mouseleave: this.onMouseLeave, focusin: this.onFocusIn, focusout: this.onFocusOut });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseTooltip.prototype, "isVisible", {
        get: function () {
            return typeof this.visible !== 'undefined'
                ? this.visible
                : this.innerVisible;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseTooltip.prototype, "IconActionDelete", {
        get: function () {
            return __vue_component__;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseTooltip.prototype, "closeIconColor", {
        get: function () {
            return {
                brand: colorGrayDusk,
                black: colorBaseWhite,
                invert: colorGrayDusk
            }[this.variant];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseTooltip.prototype, "popperProps", {
        get: function () {
            var _a = this, appendTo = _a.appendToEl, placement = _a.placement, popperOptions = _a.popperOptions;
            return {
                appendTo: appendTo,
                placement: placement,
                popperOptions: __assign(__assign({}, popperOptions), { modifiers: [
                        {
                            name: 'offset',
                            options: {
                                offset: [0, 14]
                            }
                        }
                    ] })
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseTooltip.prototype, "arrowColor", {
        get: function () {
            var _a;
            return (_a = {},
                _a[TooltipVariant.brand] = colorBrand5,
                _a[TooltipVariant.black] = colorBaseBlack,
                _a[TooltipVariant.invert] = colorBaseWhite,
                _a)[this.variant];
        },
        enumerable: false,
        configurable: true
    });
    HseTooltip.prototype.mounted = function () {
        var _this = this;
        this.$nextTick(function () {
            var popoverTarget = _this.$refs.popoverTarget;
            if (popoverTarget)
                _this.appendToEl = popoverTarget;
        });
    };
    HseTooltip.prototype.show = function () {
        this.innerVisible = true;
    };
    HseTooltip.prototype.hide = function () {
        this.innerVisible = false;
    };
    HseTooltip.prototype.onMouseEnter = function (e) {
        this.show();
        /**
         * Вызывается при наведении на элемент
         * @type {MouseEvent}
         */
        this.$emit('mouseenter', e);
    };
    HseTooltip.prototype.onMouseLeave = function (e) {
        this.hide();
        /**
         * Вызывается при потере наведения
         * @type {MouseEvent}
         */
        this.$emit('mouseleave', e);
    };
    HseTooltip.prototype.onFocusIn = function (e) {
        this.show();
        /**
         * Вызывается при фокусе
         * @type {FocusEvent}
         */
        this.$emit('focusin', e);
    };
    HseTooltip.prototype.onFocusOut = function (e) {
        this.hide();
        /**
         * Вызывается при потере фокуса
         * @type {FocusEvent}
         */
        this.$emit('focusout', e);
    };
    __decorate([
        Prop(),
        __metadata("design:type", Boolean)
    ], HseTooltip.prototype, "closable", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Boolean)
    ], HseTooltip.prototype, "visible", void 0);
    __decorate([
        Prop({
            default: ''
        }),
        __metadata("design:type", String)
    ], HseTooltip.prototype, "content", void 0);
    __decorate([
        Prop(EnumProp(TooltipVariant.brand, TooltipVariant)),
        __metadata("design:type", String)
    ], HseTooltip.prototype, "variant", void 0);
    __decorate([
        Prop({
            default: 'auto'
        }),
        __metadata("design:type", String)
    ], HseTooltip.prototype, "placement", void 0);
    __decorate([
        Prop({
            type: Object,
            default: function () { return ({}); }
        }),
        __metadata("design:type", Object)
    ], HseTooltip.prototype, "popperOptions", void 0);
    HseTooltip = __decorate([
        Component({
            name: 'HseTooltip',
            components: {
                HsePopper: __vue_component__$1,
                HseClickableIcon: __vue_component__$2
            }
        })
    ], HseTooltip);
    return HseTooltip;
}(Vue));

export default HseTooltip;
